import { render } from "./LegalNoticePage.vue?vue&type=template&id=0fe23d69&scoped=true"
import script from "./LegalNoticePage.vue?vue&type=script&lang=js"
export * from "./LegalNoticePage.vue?vue&type=script&lang=js"

import "./LegalNoticePage.vue?vue&type=style&index=0&id=0fe23d69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe23d69"]])

export default __exports__